import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as VerificationConstants from './constants';

export function getDiscountTypeFromVerificationType(verificationType) {
  return VerificationConstants.mapVerificationTypeToDiscountType[verificationType];
}

export function getVerificationTypeFromDiscountType(discountType) {
  return VerificationConstants.mapDiscountTypeToVerificationType[discountType];
}

export function getDisplayableVerificationType(verificationType) {
  const verificationTypeMessage = VerificationConstants.VerificationTypeMessage[verificationType];
  if (verificationTypeMessage) {
    return <FormattedMessage {...verificationTypeMessage} />;
  }
}

export function getDisplayableOrgType(verificationType) {
  const orgTypeMessage = VerificationConstants.OrganizationTypeMessage[verificationType];
  if (orgTypeMessage) {
    return <FormattedMessage {...orgTypeMessage} />;
  }
}

export function changeSingleDigitDateToDoubleDigitDate(num) {
  const numString = num.toString();
  return numString.length === 1 ? '0' + numString : numString;
}

export function generateOrganizationOptionsForVerificationForm(data) {
  if (Array.isArray(data)) return [];

  return (
    data.toArray &&
    data.toArray().map(el => {
      return {
        value: el.get('id'),
        label: el.get('name'),
        text: el.get('name'),
      };
    })
  );
}
